import {
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ListHead from "../elements/table/ListHead";
import ListContent from "./ListContent";
import ListToolbar from "./ListToolbar";
import Loading from "../Loading/loading";

export default function ListTable({
  filteredData,
  fetchData,
  addModal,
  columnFields,
  tableName,
  pageSize,
  page,
  setMessage,
  setSnackbarOpen,
  userType,
  handleUserTypeChange,
  handleFilterByName,
  filterName,
  loading,
}) {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");

  const handleRequestSort = (event, property) => {
    if (property === "name") {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    }
  };

  const noUsers= !filteredData.length && !filterName;
  const isNotFound = !filteredData.length && !!filterName;
  const cumulativeProductCount = page * pageSize;

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          {tableName}
        </Typography>
        {addModal}
      </Stack>

      <Card>
        <ListToolbar
          filterName={filterName}
          onFilterName={handleFilterByName}
          handleUserTypeChange={handleUserTypeChange}
          userType={userType}
        />
        <TableContainer sx={{ minWidth: 600 }}>
          {loading ? (
            <Loading />
          ) : (
            <Table>
              <ListHead
                order={order}
                orderBy={orderBy}
                headLabel={columnFields}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredData?.map((row, index) => (
                  <ListContent
                    key={row.id}
                    row={row}
                    columns={columnFields}
                    index={cumulativeProductCount + index}
                    fetchData={fetchData}
                    tableName={tableName}
                    setMessage={setMessage}
                    setSnackbarOpen={setSnackbarOpen}
                  />
                ))}
              </TableBody>

              {noUsers && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No users have been added yet
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      align="center"
                      colSpan={7}
                      sx={{ py: 3, textAlign: 'center' }}>
                      <Typography variant="body2">
                        No matching users found
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          )}
        </TableContainer>
      </Card>
    </>
  );
}
